import { render, staticRenderFns } from "./MediaPlacements.vue?vue&type=template&id=8a8885b4&"
import script from "./MediaPlacements.vue?vue&type=script&lang=js&"
export * from "./MediaPlacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports